export const gender = {
  man: 1,
  woman: 2,
}

export const isGenderSpecified = (check) => {
  return Object.values(gender).includes(check)
}
